import validators from '../../../../utilities/validators';

const validator = (isCreation = true) =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('currency'),
        validators.requiredString('storeName'),
        validators.only(() => isCreation, validators.requiredString('secretKey')),
        validators.requiredString('paymentEndpoint')
    );

export default validator;
